import { TOP_BAR_BACK, TOP_BAR_RELATED_VIDEOS } from '../../logic/player/player.constants';
import { t } from '../i18n';
import { TOP_BAR_ITEMS } from './audio.constants';

// eslint-disable-next-line no-bitwise
const toHex = (red, green, blue) => blue | (green << 8) | (red << 16);

const format = (input, args) => {
  const list = input.map(colors => {
    const [r, g, b] = colors.split(',').map(Number);

    return 0xff000000 + toHex(r, g, b);
  });

  return args.amount === 1 || list.length === 1 ? list[0] : list;
};

const group = (number, grouping) => {
  const grouped = Math.round(number / grouping) * grouping;

  return Math.min(grouped, 255);
};

const extractProminentColors = (data, args) => {
  const colors = {};

  for (let i = 0; i < data.length; i += 40) {
    const rgb = [group(data[i], args.group), group(data[i + 1], args.group), group(data[i + 2], args.group)].join();

    colors[rgb] = colors[rgb] ? colors[rgb] + 1 : 1;
  }

  return format(
    Object.entries(colors)
      .sort(([, a], [, b]) => (a > b ? -1 : 1))
      .slice(0, args.amount)
      .map(([rgb]) => rgb),
    args,
  );
};

export const getColors = (stage, url) =>
  new Promise((resolve, reject) => {
    const canvas = stage.platform.getDrawingCanvas();
    const context = canvas.getContext('2d');
    context.imageSmoothingEnabled = true;

    const image = new Image();

    image.onload = () => {
      const imageWidth = image.width;
      const imageHeight = image.height;

      canvas.width = Math.round(imageWidth);
      canvas.height = Math.round(imageHeight);

      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      const { data } = context.getImageData(0, 0, canvas.width, canvas.height);

      resolve(extractProminentColors(data, { amount: 2, group: 15 }));
    };

    image.onError = error => {
      reject(error);
    };

    image.crossOrigin = 'Anonymous';
    image.src = url;
  });

const defaultTopBarItems = [
  {
    id: TOP_BAR_ITEMS.BACK,
    icon: 'ArrowLeftWithBase',
    text: t('nav.backToNav'),
    action: TOP_BAR_BACK,
  },
  {
    id: TOP_BAR_ITEMS.EPISODES,
    icon: 'Chapter',
    text: t('nav.episodes'),
    action: TOP_BAR_RELATED_VIDEOS,
  },
];

export const getTopBarItems = ({ hasRelatedEpisodes } = {}) =>
  defaultTopBarItems.filter(({ id }) => {
    switch (id) {
      case TOP_BAR_ITEMS.EPISODES:
        return hasRelatedEpisodes;
      default:
        return true;
    }
  });
